module.exports = {
  language: {
    name: '中文'
  },
  layout:{
    myself:'personalCenter',
    loginOut:'loginOut',
  },
  index:{
    clientOrder:'The customer places an order',
    business:'The merchant takes the order',
    clientSend:'Samples are sent by customers',
    testType:'Detection type',
    testTypeRemark:'Please select the test type to place an order',
    version:'version',
    new:'new',
    old:'old',
  },
  user: {
    login:'login',
    register:'register',
    loginUsername:'please input email or phone',
  },
  order:{
    sampleBasicInformation:'Basic information about the sample',
    sampleName:'Name',
    inputSampleName:'Enter a name for the sample',
    sampleElement:'Element',
    inputSampleElement:'Enter the sample elements',
    sampleQuantity:'Quantity',
    sampleSync:'Sync Num',
    inputSampleSync:'Synchronize the numbers below',
    sampleNumber:'Number',
    inputSampleNumber:'Enter the  number',
    orderRemark:'order remarks',
    inputOrderRemark:'Enter the order remarks',
  }
}



// WEBPACK FOOTER //
// ./src/components/language/en.js